import React from "react";
import { OrgChartEditor } from "../../../quality/org-charts/editor";

/**
 * HSE/KS Org Chart Editor - Rediger organisasjonskart (ISO 9001:2015 kap. 5.3)
 */
export const HseKsOrgChartEditor = () => {
  return <OrgChartEditor />;
};

